import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import {
  WorkoutContainerHeaderTwo,
  WorkoutContainerHeaderThree,
  WorkoutContainerText,
  WorkoutTextHeader
} from '../../../styles/common-styles.js';
import styled from 'styled-components/native';
import StreakDay from './StreakDay.js';

function StreakRow(props) {

  const {week, checkForDuplicateDay} = props;

  let streakCompletedFlag = 0;
  let completedWorkoutCounter = 0;

  week.forEach((item, i) => {
    if(item.completed == true){
      completedWorkoutCounter++
    }
  })

  if(completedWorkoutCounter > 2){
    streakCompletedFlag = 1;
  }

  return (
      <StreakRowParent>
        {streakCompletedFlag === 0 && (
            <StreakWeekRow>
              <StreakDay checkForDuplicateDay={checkForDuplicateDay}/>
              {week.map((day, index) => (
                  <StreakDay
                      key={index}
                      date={day.day}
                      completed={day.completed}
                      index={day.index}
                      checkForDuplicateDay={checkForDuplicateDay}
                  />
              ))}
              <StreakDay checkForDuplicateDay={checkForDuplicateDay}/>
            </StreakWeekRow>
        )}

        {streakCompletedFlag === 1 && (
            <StreakWeekRowCompleted>
              <GradientBackground colors={['rgba(234,178,24,1)', 'rgba(192,76,151,1)']} start={[0.0, 0.5]} end={[1.0, 0.5]} locations={[0.0, 1.0]} />
              <StreakDay checkForDuplicateDay={checkForDuplicateDay}/>

              {week.map((day, index) => (
                  <StreakDay
                      key={index}
                      date={day.day}
                      completed={day.completed}
                      isStreak={true}
                      checkForDuplicateDay={checkForDuplicateDay}
                  />
              ))}
              <StreakDay isStreak={true} displayFlame={true} checkForDuplicateDay={checkForDuplicateDay}/>
            </StreakWeekRowCompleted>
        )}
      </StreakRowParent>
  );

}

export const StreakRowParent = styled.View`
  width:100%;
`

export const StreakWeekRow = styled.View`
  width:100%;
  margin-top:4px;
  margin-bottom:4px;
  padding:3px 0px 3px 0px;
  display:flex;
  justify-content:space-evenly;
  align-items:center;
  flex-direction:row;
  border-radius:50px;
`

export const StreakWeekRowCompleted = styled(StreakWeekRow)`
  width:100%;
  margin-top:7px;
  margin-bottom:7px;
  padding:3px 0px 3px 0px;
  display:flex;
  justify-content:space-evenly;
  align-items:center;
  flex-direction:row;
  border-radius:50px;
`

export const GradientBackground = styled(LinearGradient)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50px;
`;


export const StreakFlame = styled.View`
  width:25px;
  height:35px;
  background:red;
`

export default StreakRow;
